'use client'

import { gaMeasurementId } from '@/util/env'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

declare global {
  interface Window {
    gtag?: (type: string, event: string, value?: unknown) => void
  }
}

export function usePageView() {
  const pathname = usePathname()
  useEffect(() => {
    if (!gaMeasurementId || !window?.gtag || !window?.location?.href) { return }
    window.gtag('event', 'page_view', {
      page_location: window.location.href,
      page_path: pathname,
      page_title: document.title
    })
  }, [pathname])
}